export const logTypes = {
  warning : [
    { eventCode: 'w', event: 'Warnings During Login' },
    { eventCode: 'limit_wc', event: 'Blocked Account' },
  ],
  information : [
    { eventCode: 'cs', event: 'Code Sent' },
    { eventCode: 'cls', event: 'Code/Link Sent' },
    { eventCode: 'du', event: 'Deleted User' },
  ],
  success : [
    { eventCode: 's', event: 'Success Login' },
    { eventCode: 'sce', event: 'Success Change Email' },
    { eventCode: 'scu', event: 'Success Change Username' },
    { eventCode: 'slo', event: 'Success Logout' },
    { eventCode: 'sdu', event: 'Successful User Deletion' },
    { eventCode: 'scpr', event: 'Success Change Password Request' },
    { eventCode: 'svr', event: 'Success Verification Email Request' },
    { eventCode: 'sv', event: 'Success Verification Email' },
    { eventCode: 'scpn', event: 'Success Change Phone Number' },
    { eventCode: 'scp', event: 'Success Change Password' },
    { eventCode: 'ss', event: 'Success Signup' },
  ],
  failure : [
    { eventCode: 'fdu', event: 'Failed User Deletion' },
    { eventCode: 'fv', event: 'Failed Verification Email' },
    { eventCode: 'f', event: 'Failed Login' },
    { eventCode: 'fcp', event: 'Failed Change Password' },
    { eventCode: 'fce', event: 'Failed Change Email' },
    { eventCode: 'fcu', event: 'Failed Change Username' },
    { eventCode: 'fcpn', event: 'Failed Change Phone Number' },
    { eventCode: 'fvr', event: 'Failed Verification Email Request' },
    { eventCode: 'fcpr', event: 'Failed Change Password Request' },
    { eventCode: 'fn', event: 'Failed Sending Notification' },
    { eventCode: 'fs', event: 'Failed Signup' },
    { eventCode: 'flo', event: 'Failed Logout' },
    { eventCode: 'fu', event: 'Failed Login (invalid email/username)' },
    { eventCode: 'fp', event: 'Failed Login (wrong password)' },
    { eventCode: 'fc', event: 'Failed by Connector' },
  ]
}
